module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (25).067800ea.jpg";